import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      canLogin: localState.canLogin,
      error: localState.error,
      isAdmin: localState.isAdmin,
      isDisabled: !localState.canLogin,
      loginUrl: localState.loginUrl,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
